import { FirebaseMessaging, Importance } from '@capacitor-firebase/messaging';
import { NotificationType } from 'src/shared/models/push-notification/push-notification';

export const PUSH_NOTIFICATION_CHANNELS = [
  {
    id: NotificationType.None.toString(),
    name: 'Default',
    description: 'General notifications without a specific category.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.DutyMessage.toString(),
    name: 'Duties',
    description: 'Updates and messages about your duties and shifts.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.PinboardPost.toString(),
    name: 'Pinboard posts',
    description: 'New posts or updates on the pinboard.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.MessageReply.toString(),
    name: 'Messages',
    description: 'Replies to your messages and conversations.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.NewNotificationFromRota.toString(),
    name: 'Rota notifications',
    description: 'Announcements and alerts sent by Rota.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.EnquiryMessage.toString(),
    name: 'Enquiries',
    description: 'Updates to your enquiries and answers from Rota.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.RequestMessage.toString(),
    name: 'Requests',
    description: 'Responses or changes to your requests.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.PresenceMonitoring.toString(),
    name: 'Presence Monitoring',
    description: 'Alerts about presence monitoring and check-ins.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.Info.toString(),
    name: 'Info',
    description: 'General information messages from Rota.',
    importance: 4 as Importance,
  },
  {
    id: NotificationType.Statistic.toString(),
    name: 'Statistics',
    description: 'Reports and statistics relevant to your account.',
    importance: 4 as Importance,
  },
];

export const createNotificationChannels = async () => {
  PUSH_NOTIFICATION_CHANNELS.forEach(async (channel) => {
    await FirebaseMessaging.createChannel({
      id: channel.id,
      name: channel.name,
      importance: channel.importance,
      description: channel.description,
    });
  });
};
